import * as React from "react";
import * as SpinkitSpinner from "react-spinkit";
import { blue } from "./constants";
export var Spinner = function (props) { return (React.createElement(SpinkitSpinner, { fadeIn: props.fadeIn ? undefined : "none", color: blue, className: props.className })); };
//# sourceMappingURL=Spinner.js.map